import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '../_shared/shared.service';
import { Order } from './order';

@Injectable({ providedIn: 'root' })
export class OrderService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];

	paymentReceivedTypes: any = [
		{ value: "", name: "" },
		{ value: "CR", name: 'Credit Card' },
		{ value: "AH", name: 'eCheck(ACH)' },
		{ value: "CH", name: 'Check' },
		{ value: "CC", name: 'Certified Check' },
		{ value: "PC", name: 'Personal Check' },
		{ value: "MO", name: 'Money Order' },
		{ value: "PP", name: 'Paypal' },
		{ value: "CA", name: 'Cash' },
		{ value: "CV", name: 'Credit Voucher' },
	];
	
	paymentDepositTypes: any = [
		{ value: "", name: "" },
		{ value: "0008-191786", name: "BOH - Real Estate Esc" },
		{ value: "0007-705069", name: "BOH - Activity Esc" },
		{ value: "7195082883", name: "Wells - KBM Resorts" },
		{ value: "8123774583", name: "Wells - KBM Maui" },
		{ value: "6123021286", name: "Wells - PGP" },
	];

	invoiceDetailTypes: any = [
		{ value: "", name: "" },
		{ value: 5, name: "ACH Authorized" },
		{ value: 6, name: "ACH Requested" },
		{ value: 7, name: "Check In Mail" },
		{ value: 2, name: "Payment Received" },
		{ value: 4, name: "Refund Issued" },
		{ value: 8, name: "Credit Voucher Applied" },
		{ value: 9, name: "Credit Card Voided" },
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'order';

	add(order: Order): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(order));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, order);
	}

	update(order: Order): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, order);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	emailContract(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/email-contract-to-guest`, data);
	}
	emailInvoice(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/email-reservation-confirmation-to-guest`, data);
	}
	emailCheckInDetails(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/email-check-in-details-to-guest`, data);
	}
	emailRentalCarConfirmation(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/email-rental-car-confirmation`, data);
	}

	orderInvoiceDetailAdd(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/order-invoice-details`, data);
	}

	updateOrderInvoiceDetail(data: any): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/order-invoice-details`, data);
	}

	// updateOrderSummery(data: any): Observable<ApiResponse> {
	// 	return this.http.patch<ApiResponse>(`${environment.apiUrl}/order/update/summary`, data);
	// }

	updateOrderSummery(order: any): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/update/summary`, order);
	}

	deleteOrderInvoiceDetail(orderInvoiceDetailId: any): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/order-invoice-details/${orderInvoiceDetailId}`);
	}

	sendEmailPaymentRecieveToGuest(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/email-payment-received-to-guest`, data);
	}

	synchReservationToYieldMaxWithoutSQS(data: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/reservations/hard-sync-to-yieldmax`, data);
	}

	capturePriorAuthAndSync(paymentConfirmId: number): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/payment/capturePriorAuthAndSync`, { paymentConfirmId });
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
